const BASE_PATH = '/book'
const HEADER_PATH = `${BASE_PATH}/:id/header`
const PAURI_PATH = `${HEADER_PATH}/:headerId/pauri`

const BASE_META = {
  allowAnonymous: false,
  parent: 'BookList'
}

export default [
  /* ------------------------------------------------------- header ------------------------------------------------------- */
  {
    path: HEADER_PATH,
    name: 'header',
    component: () => import('@/views/book/type-3/header/index.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Book Header',
      permissions: ['book_edit']
    }
  },
  {
    path: `${HEADER_PATH}/add`,
    name: 'add-header',
    component: () => import('@/views/book/type-3/header/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Add Book Header',
      permissions: ['book_edit']
    }
  },
  {
    path: `${HEADER_PATH}/edit/:headerId`,
    name: 'edit-header',
    component: () => import('@/views/book/type-3/header/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Edit Book Header',
      permissions: ['book_edit']
    }
  },

  /* ------------------------------------------------------- pauri & slok ------------------------------------------------------- */
  {
    path: `${PAURI_PATH}`,
    name: 'headerPauri',
    component: () => import('@/views/book/type-3/header/pauri/index.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Pauri & Slok',
      permissions: ['book_edit']
    }
  },
  {
    path: `${PAURI_PATH}/add/:type`,
    name: 'add-header-pauri',
    component: () => import('@/views/book/type-3/header/pauri/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Add Pauri',
      permissions: ['book_edit']
    }
  },
  {
    path: `${PAURI_PATH}/edit/:pauriId/:type`,
    name: 'edit-header-pauri',
    component: () => import('@/views/book/type-3/header/pauri/action.vue'),
    meta: {
      ...BASE_META,
      pageTitle: 'Edit Pauri',
      permissions: ['book_edit']
    }
  }
]
